export enum UserLevels {
	GOAL_GETTER_I = 0,
	GOAL_GETTER_II = 1,
	LEADER_I = 3,
	LEADER_II = 4,
	TRUE_LEADER_I = 5,
	TRUE_LEADER_II = 6,
	PARTNER = 7,
}
